var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_vm._v("\n    "+_vm._s(_vm.$auth.user().name)+"\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }